import {Injectable} from '@angular/core';
import {DefaultDataServiceConfig, Logger} from '@ngrx/data';
import {HttpClient} from '@angular/common/http';
import {AbstractDataServiceV2} from '../../../../../core/service/v2/dataservice/abstractDataServiceV2';
import {CustomizeHttpUrlGenerator} from '../../../../../../store/core/url/customizeHttpUrlGenerator';
import {ReportDefinitionModel} from '../../../api/entity/reportDefinition.model';
import {ReportDefinitionConverter} from '../../../api/entity/converter/reportDefinition.converter';

@Injectable()
export class ReportDefinitionDataService extends AbstractDataServiceV2<ReportDefinitionModel, ReportDefinitionConverter> {
    constructor(http: HttpClient,
                httpUrlGenerator: CustomizeHttpUrlGenerator,
                logger: Logger,
                config: DefaultDataServiceConfig,
                converter: ReportDefinitionConverter) {
        super('ReportDefinition', http, httpUrlGenerator, logger, config, converter);
    }
}
